import * as React from 'react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useZstdLoading } from './useZstdLoading';

type Props = {};
export const LoadingTopProgress = (props: Props) => {
  const { cnt } = useZstdLoading();
  const [debouncedCnt, setDebouncedCnt] = useState(cnt);
  useEffect(() => {
    if (cnt > 0) {
      setDebouncedCnt(cnt);
      return;
    }
    let handler = setTimeout(() => {
      setDebouncedCnt(cnt);
      handler = null;
    }, 2000);

    return () => {
      if (handler) clearTimeout(handler);
    };
  }, [cnt]);
  return (
    <>
      <Body className={debouncedCnt > 0 ? 'show' : ''}></Body>
    </>
  );
};

const Body = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 6.11px;
  z-index: 1002;

  background: linear-gradient(90deg, #fff 0%, #407edb 30%, #2e408e 50%, #407edb 70%, #fff 100%);
  background-size: 200% 100%;
  animation: loading 2s infinite linear;
  //display: none;
  animation-play-state: paused;
  transition: opacity 0.5s ease-in-out;
  opacity: 0;

  &.show {
    //display: unset;
    opacity: 1;
    animation-play-state: running;
  }

  @keyframes loading {
    0% {
      background-position: 200% center;
    }
    100% {
      background-position: 0% center;
    }
  }
`;
